"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Can I really try it free?",
  answer: "Yes. You get 3 full days to build, customize, and preview your site. You only pay when you publish — and you can cancel any time before then with zero charge."
}, {
  question: "What happens after the free trial?",
  answer: "If you decide to publish, you pick a plan ($20, $30, or $99/mo) and your site goes live. If you don't, your draft is saved for 30 days in case you change your mind — no card charged."
}, {
  question: "Can I switch plans later?",
  answer: "Anytime. Upgrade or downgrade from your dashboard — the change kicks in immediately and we prorate the difference."
}, {
  question: "Do I own my website?",
  answer: "Yes. Your site is built on WordPress, which means you can export it, move it, or take it elsewhere. We're not a walled garden."
}, {
  question: "Is hosting really included?",
  answer: "Yes — every plan includes fast, secure hosting, free SSL, and automatic backups. You don't need a separate hosting provider."
}, {
  question: "What if I need help building my site?",
  answer: "Starter and Pro plans get email support. Business plan includes a one-time done-for-you build — our team builds the entire site for you based on a short questionnaire."
}, {
  question: "Do you support Spanish?",
  answer: "Yes. Every site can be built fully bilingual EN/ES from day one. Your dashboard is also available in Spanish."
}, {
  question: "Can I cancel anytime?",
  answer: "Yes. Cancel from your dashboard in two clicks. No phone calls, no retention specialists, no fees."
}];
export default function PricingFAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return;
}